import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseStatsDto } from '../../../shared/modules/base/dtos/base-stats.dto';

/**
 * Account stats DTO
 */
@CaslSubject(AppSubjectEnum.ACCOUNT)
export class AccountsStatsDto extends BaseStatsDto {
	active!: number;
	onHold!: number;
	closed!: number;
}
